import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import allAPI from "../../api/api";

const initialState = {
  allServices: [],
  services: { servicesData: [], count: 0 },
  serviceDetail: {},
};

export const getAllServices = createAsyncThunk(
  "serviceData/getAllServices",
  async (payload) => {
    try {
      const response = await allAPI.services.getServices(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const createService = createAsyncThunk(
  "programData/createService",
  async (payload) => {
    console.log("createService thunk received", payload);

    try {
      let response;
      if (payload.formData instanceof FormData) {
        // send FormData directly
        response = await allAPI.services.createServices(payload.formData);
      } else {
        // normal JSON payload
        const { pagination, ...rest } = payload;
        console.log("rest palyload", rest);
        response = await allAPI.services.createServices(rest.payload);
      }

      if (response.status === 201 && payload.pagination) {
        return { data: response.data, pagination: payload.pagination };
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);


export const getServiceById = createAsyncThunk(
  "serviceData/getServiceById",
  async (payload) => {
    try {
      const response = await allAPI.services.getServiceById(payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const updateService = createAsyncThunk(
  "serviceData/updateService",
  async (payload) => {
    try {
      let ID = payload.ID;
      delete payload.ID;
      const response = await allAPI.services.updateServices(ID, payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const createPrgramServiceMapping = createAsyncThunk(
  "programData/createPrgramServiceMapping",
  async (payload) => {
    try {
      const response = await allAPI.services.createPrgramServiceMapping(
        payload
      );
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const deletePrgramServiceMapping = createAsyncThunk(
  "programData/deletePrgramServiceMapping",
  async (payload) => {
    try {
      const response = await allAPI.services.deletePrgramServiceMapping(
        payload
      );
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const uploadImage = createAsyncThunk(
  "/serviceImageUpdate",
  async (formData) => {
    try {
      const response = await allAPI.services.uploadServiceImage(
        formData.id,
        formData
      );
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const subServiceImgUpload = createAsyncThunk(
  "/serviceImageUpdate",
  async (payload) => {
    try {
      let formData = new FormData();

      formData.append("service_image", payload.file);
      console.log(formData, "formData");
      const response = await allAPI.services.subServiceImgUpload(
        payload.id,
        formData
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);
export const updateServiceType = createAsyncThunk(
  "/updateServiceType",
  async (formData) => {
    try {
      console.log(formData)
      const response = await allAPI.services.updateServiceType(
        formData
      );
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  },
);
const serviceSlice = createSlice({
  name: "serviceData",
  initialState,
  reducers: {
    setService: (state, action) => {
      state.serviceDetail = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllServices.pending, (state) => {
        // console.log("pending");
      })
      .addCase(getAllServices.fulfilled, (state, action) => {
        console.log(action.payload, "response");
        if (action.payload.servicesData) {
          state.services = action.payload;
        } else {
          state.allServices = action.payload;
        }
      })
      .addCase(getAllServices.rejected, (state, action) => {
        // console.log("rejected", action.error.message);
      })
      .addCase(createService.pending, (state) => {
        // console.log("pending");
      })
      .addCase(createService.fulfilled, (state, action) => {
        let currentPage = action.payload.pagination.pageIndex;
        let currentPageSize = action.payload.pagination.pageSize;
        state.services.count = state.services.count + 1;
        console.log(
          currentPage + 1 * currentPageSize,
          action.payload.data,
          "current page size"
        );
        if (currentPage + 1 * currentPageSize > state.services.count) {
          state.services.servicesData = [
            ...state.services.servicesData,
            action.payload.data,
          ];
        }
      })
      .addCase(createService.rejected, (state, action) => {
        // console.log("rejected", action.error.message);
      })
      .addCase(getServiceById.pending, (state) => {
        // console.log("pending");
      })
      .addCase(getServiceById.fulfilled, (state, action) => {
        // console.log(action.payload, "response");
        state.serviceDetail = action.payload;
      })
      .addCase(getServiceById.rejected, (state, action) => {
        // console.log("rejected", action.error.message);
      })
      .addCase(updateService.pending, (state) => {
        // console.log("pending");
      })
      .addCase(updateService.fulfilled, (state, action) => {
        // console.log(action.payload, "response");
        state.serviceDetail = action.payload;
      })
      .addCase(updateService.rejected, (state, action) => {
        // console.log("rejected", action.error.message);
      })
      .addCase(uploadImage.pending, (state, action) => {
        console.log("pending");
      })
      .addCase(uploadImage.fulfilled, (state, action) => {
        console.log(action.payload, "response");
        state.serviceDetail = action.payload;
      })
      .addCase(uploadImage.rejected, (state, action) => {
        console.log(action.error, "response");
      });
  },
});

export const { setService } = serviceSlice.actions;

export default serviceSlice.reducer;
